import { useState } from 'react';
import { photos, photosNA } from '../constants/photos';
import { ReactComponent as PlusIcon } from "../icons/plus.svg";
import { ReactComponent as MinusIcon } from "../icons/minus.svg";
import { ReactComponent as CalendarIcon } from "../icons/calendar.svg";
//import { getParents, makeComplexId } from "../constants/utilities";
import { Conner } from "../constants/utilities";
import { ReactComponent as NewWindowIcon } from "../icons/new-window.svg";


export default function PhotosList() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (e,index) => {
    const tagname = e.target.tagName;
    let parents = Conner.getParents(e.target, ".level1");

    e.preventDefault();
    e.stopPropagation();
    if (parents.length && (tagname !== 'LI' )) {
      setActiveIndex(activeIndex === index ? null : index);
    }
  }

  return (
    <>
      <h3>Reunion Photos</h3>
      <ul className="accordion">
        {
          photos.map((group, index) => {
            const { label, groups } = group;
            return <CustomListItem key={index} curIndex={index} activeIndex={activeIndex} label={label} groups={groups} toggleItem={toggleItem} />
          })
        }
      </ul>
    </>
  );
}

function CustomListItem({curIndex, activeIndex, label, groups, toggleItem }) {

  const groupId = Conner.makeComplexId();
  const isExpanded = (curIndex === activeIndex);
  const srExpandedMsg = curIndex===activeIndex?"Expanded, select to collapse.":"Collapsed, select to expand.";

  // const handleKeyDown = (event) => {
  //   if (event.key === Conner.key.enter) {
  //     let ele = event.target;
  //     let parent = ele.parentElement;
  //     if (parent.tagName === 'LI' && parent.classList.contains('level1')) {
  //       handleClick(event, curIndex);
  //     }
  //   }
  // };

  const handleClick = (event, curIndex) => {
    toggleItem(event, curIndex);
  }

  return (
    <>
      <li id={curIndex} key={curIndex} className="level1" aria-live="polite" aria-label={`Reunion photos from year ${label}. ${srExpandedMsg}`}>
        {/* <div tabIndex="0" onClick={(e) => handleClick(e,curIndex)} onKeyDown={handleKeyDown}  aria-expanded={isExpanded} aria-controls={groupId}> */}
        <button onClick={(e) => handleClick(e,curIndex)}   aria-expanded={isExpanded} aria-controls={groupId}>
          <div className="pre-icon">{<CalendarIcon aria-hidden="true" />}</div>
          <div className="year" aria-hidden="true">{label}</div>
          <div className="expcol-button">{isExpanded ? <MinusIcon aria-hidden="true" />: <PlusIcon aria-hidden="true" />}</div>
        </button>
        <ul id={groupId} className={`level2 ${activeIndex === curIndex ? "active" : "" }`} aria-hidden={curIndex!==activeIndex}>
          {
            Object.keys(groups).map((group,idx) => {
              return (
                <li id={`groupKey_${idx}`} key={`groupKey_${idx}`} className="">
                  <CreateCustomLink curIndex={curIndex} activeIndex={activeIndex} year={label} group={group} link={groups[group]} />
                  <span className="expcol-button"><NewWindowIcon /></span>
                </li>
              );
            })
          }
        </ul>
      </li>
    </>
  )
}

function handleCustomClick(event, url) {
  if (url === photosNA) {
    alert("No photos found for this library!\n\nIf you have any photos for this reunion, please contact technical support for the site.");
  }
  else if (url.startsWith('http')) {
    window.open(url, "ConnerPhotos").focus();
  }
}

function CreateCustomLink({ curIndex, activeIndex, year, group, link }) {
  let thisLink = null;

  if (link !== photosNA) {
    // thisLink = <button tabIndex={curIndex===activeIndex?"0":"-1"} href="#" onClick={(event) => handleCustomClick(event, link)} onKeyDown={(event) => handleCustomClick(event, link)} target="ConnerPhotos" className="liblink" aria-label={`${group} for year ${year}, opens in new window`}>{group}</button>
    thisLink = <button tabIndex={curIndex===activeIndex?"0":"-1"} onClick={(event) => handleCustomClick(event, link)} target="ConnerPhotos" className="liblink" aria-label={`${group} for year ${year}, opens in new window`}>{group}</button>
  }
  else {
    thisLink = <button tabIndex={curIndex===activeIndex?"0":"-1"} className="lib" onClick={(event) => handleCustomClick(event, link)} aria-label={`${group} for year ${year}, opens in new window`}>{group}</button>
  }

  return thisLink
}
